var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 39,
    viewBox: "0 0 61 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8556_480)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.9375,
    height: 39,
    rx: 3,
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3815 26.6927H23.6299L25.9764 13.2432H29.7279L27.3815 26.6927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9814 13.5726C40.2414 13.3005 39.0678 13 37.6165 13C33.9116 13 31.3027 14.8313 31.2867 17.4496C31.2559 19.3813 33.1546 20.4542 34.5747 21.0983C36.0261 21.7565 36.5195 22.1861 36.5195 22.7728C36.5048 23.6738 35.3467 24.0891 34.2666 24.0891C32.7687 24.0891 31.9662 23.875 30.7465 23.3737L30.2525 23.1588L29.7275 26.178C30.6074 26.5495 32.2286 26.8793 33.9116 26.8937C37.8481 26.8937 40.4109 25.0908 40.4413 22.3006C40.4562 20.7695 39.4536 19.5964 37.2922 18.6378C35.98 18.0224 35.1764 17.6074 35.1764 16.9778C35.1918 16.4054 35.8561 15.8191 37.3373 15.8191C38.5569 15.7903 39.453 16.0621 40.1319 16.334L40.4712 16.4769L40.9814 13.5726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9675 21.928C46.2764 21.1553 47.4653 18.1649 47.4653 18.1649C47.4497 18.1936 47.7737 17.378 47.9589 16.8773L48.2211 18.0362C48.2211 18.0362 48.9315 21.2556 49.0858 21.928C48.4995 21.928 46.7085 21.928 45.9675 21.928ZM50.5984 13.2432H47.6965C46.8016 13.2432 46.1218 13.4862 45.7357 14.3591L40.1631 26.6925H44.0996C44.0996 26.6925 44.7476 25.0325 44.8869 24.675C45.3188 24.675 49.1482 24.675 49.7037 24.675C49.8114 25.1472 50.1514 26.6925 50.1514 26.6925H53.625L50.5984 13.2432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4959 13.2432L16.8218 22.4144L16.4203 20.5544C15.741 18.4082 13.6107 16.0763 11.2334 14.9168L14.5987 26.6784H18.566L24.4629 13.2432H20.4959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4103 13.2432H7.37425L7.3125 13.5149C12.021 14.631 15.1393 17.3213 16.4205 20.555L15.1083 14.3737C14.8923 13.5147 14.2284 13.2715 13.4103 13.2432Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8556_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 39,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.e2d60746792a993270ce8b8a454d15b2.svg";
export { ForwardRef as ReactComponent };